import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Styles
import './select-label.scss';

function SelectLabel({
    id,
    srLabel,
    value,
    ariaProps,
    listOfOptions,
    propertyName,
    visibleProperty,
    selectHandler,
    isSelectDisabled,
    isRequired,
    importedClasses
}) {
    const selectClasses = `select ${importedClasses}`;
    return (
        <Fragment>
            {
                srLabel ? (
                    <label htmlFor={id}>
                        <span className="sr-only">{srLabel}</span>
                    </label>
                ) : ''
            }
            <select
                id={id}
                value={value}
                className={selectClasses}
                aria-labelledby={ariaProps && ariaProps.ariaLabelledBy}
                disabled={isSelectDisabled}
                required={isRequired}
                onChange={selectHandler}
                autoComplete="off">
                {
                    listOfOptions.map(group => (
                        <option key={`${id}-${group[propertyName]}`} value={group[propertyName]}>
                            {group[visibleProperty]}
                        </option>
                    ))
                }
            </select>
        </Fragment>
    );
}

SelectLabel.defaultProps = {
    visibleProperty: 'name',
    importedClasses: ''
};

SelectLabel.propTypes = {
    id: PropTypes.string,
    srLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ariaProps: PropTypes.object,
    listOfOptions: PropTypes.array,
    propertyName: PropTypes.string,
    visibleProperty: PropTypes.string,
    isSelectDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    selectHandler: PropTypes.func.isRequired,
    importedClasses: PropTypes.string
};

export default SelectLabel;



// WEBPACK FOOTER //
// ./components/select-label/select-label.js